import { render } from "../views/bubble.html?vue&type=template&id=943ff024&ts=true&external"
import script from "../scripts/bubble.ts?vue&type=script&lang=ts&external"
export * from "../scripts/bubble.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/bubble.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "943ff024"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('943ff024', __exports__)) {
    api.reload('943ff024', __exports__)
  }
  
  module.hot.accept("../views/bubble.html?vue&type=template&id=943ff024&ts=true&external", () => {
    api.rerender('943ff024', render)
  })

}


export default __exports__